export const englishToArabic = {
    // order status
    completed: "مكتملة",
    pending: "قيد الانتظار",
    claimed: "انتظار وصول السائق",
    cancelled: "ملغية",
    arrived: "وصل",
    // gender type
    male: "ذكر",
    female: "انثى",
    // transactions
    debit: "سحب",
    credit: "ايداع",
    gifts_days: "فترة",
    gifts_traffic: "بيانات",
    gifts_both: "كلاهما",
};
export const translateToArabic = (text) => {
    return englishToArabic[text];
};
